<template>
    <section class="block block-header block-action-header d-flex mb-2">
        <div class="container-fluid position-relative">
            <div class="block-header__background-wrap">
                <lazy-background v-if="image" :image="image"></lazy-background>
            </div>
            <div class="row h-100 align-items-center">
                <div class="col-12 col-xl-11 block-action-header__content">
                    <h1 v-if="title" class="uppercase">{{ title }}</h1>
                    <h2 v-if="subTitle" class="uppercase mb-3">
                        {{ subTitle }}
                    </h2>
                    <ul v-if="educations" class="newest-educations">
                        <li
                            v-for="(education, index) in educations"
                            :key="index"
                        >
                            <a :href="education.url">
                                <span>#{{ index + 1 }}</span>
                                {{ education.name }}
                                <i class="fas fa-chevron-right"></i>
                            </a>
                        </li>
                    </ul>
                    <a
                        v-if="button"
                        :href="button.url"
                        class="btn btn-primary px-4"
                        >{{ button.name }}
                        <i class="fas fa-arrow-right ml-1"></i
                    ></a>
                </div>
            </div>
            <div class="block-header__social">
                <a
                    target="_blank"
                    :href="
                        'https://twitter.com/intent/tweet?text=@Request.' + url
                    "
                >
                    <i
                        class="fab fa-square-x-twitter"
                        aria-hidden="true"
                        alt="Twitter"
                    ></i>
                </a>

                <a
                    target="_blank"
                    :href="
                        'https://www.facebook.com/sharer/sharer.php?u=@Request.' +
                            url
                    "
                >
                    <i class="fab fa-facebook-square" alt="Facebook"></i>
                </a>

                <a
                    target="_blank"
                    :href="
                        'https://www.linkedin.com/sharing/share-offsite/?url=@Request.' +
                            url
                    "
                >
                    <i class="fab fa-linkedin" alt="LinkedIn"></i>
                </a>

                <a
                    target="_blank"
                    href="https://www.instagram.com/rochorizoncollege/?hl=nl"
                >
                    <i class="fab fa-instagram" alt="Instagram"></i>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import LazyBackground from '@/components/lazy-background';

export default {
    components: {
        LazyBackground
    },
    props: {
        educations: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        subTitle: {
            type: String,
            default() {
                return '';
            }
        },
        url: {
            type: String,
            default() {
                return '';
            }
        },
        button: {
            type: Object,
            default() {
                return {};
            }
        },
        image: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.block-header__social a {
    margin-right: 5px;
}
</style>

<style lang="scss">
.block-action-header__content {
    @include media-breakpoint-up(lg) {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: flex-end;
    }
}

.block-action-header__content h1 {
    font-size: 3.25rem;

    @include media-breakpoint-up(xl) {
        font-size: 7.75rem;
    }
}

.block-action-header__content h2 {
    font-family: $font-family-condensed;
    font-weight: $font-weight-bold;
    font-size: 2rem;

    @include media-breakpoint-up(xl) {
        font-size: 3.25rem;
    }
}

.block-action-header__content .btn {
    display: block;
    margin: 0 auto;

    @include media-breakpoint-up(sm) {
        display: inline-block;
        margin: 0;
    }
}

.newest-educations {
    padding: 0;
    list-style: none;
}

.newest-educations li {
    margin-bottom: 1.5rem;
}

.newest-educations li a {
    color: $color-white;
    font-family: $font-family-condensed;
    font-size: 1.3rem;
    text-transform: uppercase;
    position: relative;
    padding-right: 20px;
    display: block;

    @include media-breakpoint-up(sm) {
        font-size: 1.425rem;
    }

    &:after {
        content: '';
        border-bottom: 2px solid $color-white;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        opacity: 0;
        transition: opacity 0.15s ease-in-out;
    }

    &:hover {
        text-decoration: none;

        &:after {
            opacity: 1;
        }
    }
}

.newest-educations span {
    margin-right: 15px;
    color: $color-gray-dark;
    opacity: 0.4;

    @include media-breakpoint-up(sm) {
        color: $color-orange;
        opacity: 1;
    }
}

.newest-educations i {
    font-size: 1.25rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
</style>
